import { useQuery } from '@tanstack/react-query'

import { ActivitiesParams, CatalogParams, getActivities, getActors, getCategories, getClients } from 'api/activityLog'
import { QUERIES, STALE_TIME } from 'constants/queries'

export function useActivities(params: ActivitiesParams) {
  return useQuery({
    queryKey: [QUERIES.ACTIVITY_LOG.ACTIVITIES, params],
    queryFn: () => getActivities(params),
    keepPreviousData: true,
  })
}

export function useCategories() {
  return useQuery({
    queryKey: [QUERIES.ACTIVITY_LOG.CATEGORIES],
    queryFn: getCategories,
    staleTime: STALE_TIME.FIVE_MINUTES,
  })
}

export function useClientsCatalog(params: CatalogParams) {
  return useQuery({
    queryKey: [QUERIES.ACTIVITY_LOG.CLIENTS, params],
    queryFn: () => getClients(params),
    keepPreviousData: true,
  })
}

export function useActorsCatalog(params: CatalogParams) {
  return useQuery({
    queryKey: [QUERIES.ACTIVITY_LOG.ACTORS, params],
    queryFn: () => getActors(params),
    keepPreviousData: true,
  })
}
